import { type OrderDraftItemApiModel } from '../api-models/OrderDraftItemApiModel'
import { type OrderItemApiModel } from '../api-models/OrderItemApiModel'

export const mapOrderItemBlanketDetails = (
  blanketItemDetailsData:
    | OrderDraftItemApiModel['blanket']
    | OrderItemApiModel['blanket']
) => {
  if (!blanketItemDetailsData) return null

  return {
    amount: blanketItemDetailsData.amount,
    price: blanketItemDetailsData.price,
    quantity:
      blanketItemDetailsData.quantity != null
        ? Number.parseFloat(blanketItemDetailsData.quantity.toString())
        : null,
  }
}
